import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-220bdc7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-justify-center tw-items-start tw-self-stretch md:tw-p-[40px] tw-p-[20px] tw-bg-[#FFFFFF]" }
const _hoisted_2 = { class: "tw-flex tw-items-start tw-flex-col tw-gap-[15px] headingWrapper tw-pb-[40px]" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[22px] tw-not-italic tw-font-semibold tw-leading-[100%]" }
const _hoisted_4 = { class: "tw-text-[#231F20] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]" }
const _hoisted_5 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-[20px] md:tw-px-[25px] tw-px-[10px] tw-py-[25px] main" }
const _hoisted_6 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[100%]" }
const _hoisted_7 = { class: "tw-flex md:tw-items-center tw-flex-col tw-gap-[5px] md:tw-gap-[10px] md:tw-flex-row tw-justify-between tw-items-start tw-self-stretch tw-rounded" }
const _hoisted_8 = { class: "left" }
const _hoisted_9 = { class: "tw-flex tw-w-[260px] tw-flex-col tw-items-start tw-gap-2.5 tw-px-0 info" }
const _hoisted_10 = { class: "tw-text-[#231f20] tw-text-[14px] tw-not-italic tw-font-medium tw-leading-[100%]" }
const _hoisted_11 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-5 tw-overflow-auto right tw-max-w-[100%] md:tw-max-w-[541px] tw-w-full" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "tw-flex tw-flex-col tw-gap-[5px] md:tw-gap-[10px] md:tw-flex-row tw-justify-between tw-items-start tw-self-stretch tw-rounded" }
const _hoisted_14 = { class: "left" }
const _hoisted_15 = { class: "tw-flex tw-w-[260px] tw-flex-col tw-items-start tw-gap-2.5 tw-px-0 info tw-py-[9px]" }
const _hoisted_16 = { class: "tw-text-[#231f20] tw-text-[14px] tw-not-italic tw-font-medium tw-leading-[100%]" }
const _hoisted_17 = { class: "tw-flex tw-flex-col tw-items-start tw-overflow-auto right tw-max-w-[100%] md:tw-max-w-[541px] tw-w-full" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "tw-flex md:tw-items-center tw-flex-col tw-gap-[5px] md:tw-gap-[10px] md:tw-flex-row tw-justify-between tw-items-start tw-self-stretch tw-rounded" }
const _hoisted_20 = { class: "left" }
const _hoisted_21 = { class: "tw-flex tw-w-[260px] tw-flex-col tw-items-start tw-gap-2.5 tw-px-0 info" }
const _hoisted_22 = { class: "tw-text-[#231f20] tw-text-[14px] tw-not-italic tw-font-medium tw-leading-[100%]" }
const _hoisted_23 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-5 tw-overflow-auto right tw-max-w-[100%] md:tw-max-w-[541px] tw-w-full" }
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = { class: "tw-flex tw-justify-start tw-items-start tw-py-[25px] tw-self-stretch tw-px-5 tw-text-[#878787] tw-text-[12px] tw-not-italic tw-font-[600] tw-leading-[100%] tw-tracking-[1.2px] tw-uppercase" }
const _hoisted_26 = { class: "tw-flex tw-px-[25px] tw-mb-[40px] tw-py-[25px] tw-flex-col md:tw-flex-row tw-justify-between md:tw-items-center tw-gap-[20px] md:tw-gap-[10px] tw-self-stretch tw-rounded-[4px] main" }
const _hoisted_27 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[100%] tw-min-w-[260px]" }
const _hoisted_28 = { class: "tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[541px]" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "9",
    viewBox: "0 0 12 9",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11.8741 2.10715L6.38429 8.33065C6.33485 8.3829 6.27527 8.42453 6.2092 8.45297C6.14312 8.48142 6.07194 8.49609 6 8.49609C5.92806 8.49609 5.85688 8.48142 5.7908 8.45297C5.72473 8.42453 5.66515 8.3829 5.61571 8.33065L0.125859 2.10715C0.081969 2.05772 0.0483386 2.00005 0.02692 1.93751C0.00550146 1.87497 -0.00327902 1.80879 0.00108975 1.74283C0.0065009 1.67633 0.0251891 1.6116 0.056049 1.55245C0.086909 1.4933 0.129313 1.44094 0.180757 1.39846L1.10405 0.624894C1.15449 0.581267 1.21315 0.548191 1.27658 0.527618C1.34002 0.507046 1.40693 0.499394 1.47337 0.505115C1.53949 0.509899 1.604 0.52781 1.66313 0.557801C1.72225 0.587792 1.77481 0.629263 1.81773 0.679792L5.91516 5.39607C5.94039 5.42106 5.97447 5.43508 6.00998 5.43508C6.04549 5.43508 6.07957 5.42106 6.10481 5.39607L10.1823 0.679792C10.2629 0.583426 10.377 0.521046 10.5017 0.505115C10.5678 0.498714 10.6345 0.50557 10.6979 0.525281C10.7613 0.544992 10.8202 0.57716 10.871 0.619902L11.8192 1.39846C11.8707 1.44094 11.9131 1.4933 11.9439 1.55245C11.9748 1.6116 11.9935 1.67633 11.9989 1.74283C12.0033 1.80879 11.9945 1.87497 11.9731 1.93751C11.9517 2.00005 11.918 2.05771 11.8741 2.10715Z",
      fill: "#387DFF"
    })
  ])
], -1))
const _hoisted_30 = ["onClick"]

import { ref, watch, reactive, computed } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import store from "@/store";
import ButtonLoading from "@/components/common/buttonLoading.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'createAndUpdateAssessmentModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  checklistId: {
    type: Number,
    required: true,
  },
},
  emits: ["update:show", "resetModalHistory"],
  setup(__props, { emit }) {

const props = __props;





const modal = reactive({
  templateName: "",
  templateVersion: "",
  templateDescription: "",
});

const listTemplate = computed(() => store.state.Assessment.listTemplate);

const isLoading = ref(false);

const isDisable = ref(true);
const isCreateAssessment = ref(true);
const showRef = ref(props.show);
const notInfoVisible = ref(true);
const isTemplateDropdownOpen = ref(false);
const templateSelected = ref<(typeof listTemplate.value)[number] | null>(null);
const isModalValue = ref(false);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) notInfoVisible.value = true;
  },
);

watch(
  () => [modal.templateName, templateSelected.value],
  () => {
    isDisable.value = !(modal.templateName || templateSelected.value);
  },
);

const handleFocusInInput = () => {
  isCreateAssessment.value = true;
  templateSelected.value = null;
};

const handleCloseModal = (fromModal = false) => {
  if (
    modal.templateName ||
    modal.templateVersion ||
    modal.templateDescription ||
    templateSelected.value?.templateId
  ) {
    isModalValue.value = true;
  }
  if (fromModal && isModalValue.value) return;

  showRef.value = false;
  modal.templateName = "";
  modal.templateVersion = "";
  modal.templateDescription = "";
  templateSelected.value = null;
  isModalValue.value = false;
  emit("update:show", showRef.value);
};

const createOrUpdateAssessment = async () => {
  isLoading.value = true;
  const isSuccess = await store.dispatch(
    "Assessment/createOrUpdateAssessmentTemplate",
    {
      checklistId: props.checklistId,
      templateId: templateSelected.value?.templateId,
      data: modal,
    },
  );
  if (isSuccess) {
    handleCloseModal();
  }
  isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] assessment-modal tw-max-w-[1040px]",
    visible: showRef.value,
    "border-radius": "4px",
    onClose: _cache[4] || (_cache[4] = ($event: any) => (handleCloseModal(true)))
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        style: {"position":"sticky","top":"0","z-index":"10","background":"white"},
        class: _normalizeClass(`modal-header`),
        title: 
        _unref(getComponentUiText)(
          'app-assess-assessment-modal-create-update-template-title-1',
        )
      ,
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
              "app-assess-assessment-history-create-or-update-assessment-template-1",
            )), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
              "app-assess-assessment-modal-create-update-template-sub-title-1",
            )), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
              "app-assess-assessment-modal-create-update-template-create-new-template-1",
            )), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getComponentUiText)(
                    "app-assess-assessment-modal-create-update-template-name-1",
                  )), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modal.templateName) = $event)),
                "data-cy": "create-and-upate-assessment-template-name",
                placeholder: 
                _unref(getComponentUiText)(
                  'app-assess-assessment-modal-create-update-placeholder-input-1',
                )
              ,
                class: _normalizeClass(`input-custom tw-rounded-[6px]  tw-text-[13px] tw-h-[56px] tw-flex tw-items-center tw-justify-between tw-gap-36 tw-self-stretch tw-px-5 tw-py-[18px] tw-bg-[#FFFFFF]  ${
                isCreateAssessment.value
                  ? 'tw-text-[#231F20]tw-bg-[#FFFFFF]'
                  : 'tw-text-[#878787] tw-bg-[#e9eaed]'
              }`),
                onFocus: handleFocusInInput
              }, null, 42, _hoisted_12), [
                [_vModelText, modal.templateName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(getComponentUiText)(
                    "app-menu-submenu-home-setup-wizard-description-title-1",
                  )), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modal.templateDescription) = $event)),
                placeholder: 
                _unref(getComponentUiText)(
                  'app-assess-assessment-modal-create-update-description-placeholder-1',
                )
              ,
                class: _normalizeClass(`input-custom tw-outline-0 tw-rounded-[6px] tw-text-[13px]  tw-h-[122px] tw-gap-36 tw-self-stretch tw-p-5 tw-py-[18px] ${
                isCreateAssessment.value
                  ? 'tw-text-[#231F20]tw-bg-[#FFFFFF]'
                  : 'tw-text-[#878787] tw-bg-[#e9eaed]'
              }`),
                onFocus: handleFocusInInput
              }, null, 42, _hoisted_18), [
                [_vModelText, modal.templateDescription]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(getComponentUiText)(
                    "app-assess-assessment-modal-create-update-version-1",
                  )), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modal.templateVersion) = $event)),
                placeholder: 
                _unref(getComponentUiText)(
                  'app-assess-assessment-modal-create-update-version-placeholder-1',
                )
              ,
                class: _normalizeClass(`input-custom tw-h-[56px] ${
                isCreateAssessment.value
                  ? 'tw-text-[#231F20]tw-bg-[#FFFFFF]'
                  : 'tw-text-[#878787] tw-bg-[#e9eaed]'
              } tw-rounded-[6px]  tw-text-[13px] tw-flex tw-items-center tw-justify-between tw-gap-36 tw-self-stretch tw-px-5 tw-py-[18px]`),
                onFocus: handleFocusInInput
              }, null, 42, _hoisted_24), [
                [_vModelText, modal.templateVersion]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", null, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessment-create-assessment-modal-select-existing-assessment-divider-or-1",
            )), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(getComponentUiText)(
              "app-assess-assessment-modal-create-update-existing-template-1",
            )), 1),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", {
              class: "tw-cursor-pointer tw-rounded-[6px] tw-flex tw-items-center tw-justify-between tw-gap-36 tw-self-stretch tw-p-5 tw-bg-[#FFFFFF] tw-max-w-[100%] md:tw-max-w-[541px] tw-w-full",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (isTemplateDropdownOpen.value = !isTemplateDropdownOpen.value))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(`${
                templateSelected.value ? 'tw-text-[#211F58]' : 'tw-text-[#B7B7B7]'
              } tw-text-[13px] tw-not-italic tw-leading-[100%]`)
              }, _toDisplayString(templateSelected.value
                  ? templateSelected.value?.templateName
                  : _unref(getComponentUiText)(
                      "app-component-assessment-create-assessment-modal-template-dropdown-placeholder-1",
                    )), 3),
              _hoisted_29
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(`tw-w-full tw-flex tw-flex-col tw-items-start tw-self-stretch tw-rounded-bl-[6px] tw-rounded-br-[6px] tw-overflow-auto tw-max-h-40 templateAssessmentWrapper ${
              isTemplateDropdownOpen.value ? '' : 'close'
            }`)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listTemplate.value, (template, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: `${template.templateId}-${index}`,
                  class: "tw-cursor-pointer tw-overflow-hidden tw-flex tw-items-center tw-gap-[15px] tw-self-stretch tw-px-[24px] tw-py-[18px] templateDropdownItem",
                  onClick: 
                () => {
                  templateSelected.value = template;
                  isTemplateDropdownOpen.value = false;
                  isCreateAssessment.value = false;
                }
              
                }, _toDisplayString(template.templateName), 9, _hoisted_30))
              }), 128))
            ], 2)
          ])
        ]),
        _createVNode(ButtonLoading, {
          title: 
          _unref(getComponentUiText)(
            !templateSelected.value
              ? 'app-component-assessment-create-assessment-modal-create-assessment-btn-1'
              : 'app-component-assessment-create-assessment-modal-update-assessment-btn-1',
          )
        ,
          disabled: isDisable.value,
          "is-loading": isLoading.value,
          onClickAction: createOrUpdateAssessment
        }, null, 8, ["title", "disabled", "is-loading"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})